<div *ngIf="job$ | async as job">
    <span
        class="job-status {{ job.closedAt ? 'closed' : 'open' }} {{ job.stage }}"
        (click)="toggleMenu($event, menu)"
    >
        <span class="content">
            {{ job.state | titlecase }}
            {{ job.stage | titlecase }}
            <ng-container *ngIf="(jobClosedReason$ | async) as closedReason">
                - {{ closedReason }}
            </ng-container>
        </span>
        <i class="pi {{
        isJobStatusMenuVisible ? 'pi-chevron-up' : 'pi-chevron-down'
      }}"></i>
    </span>
    <p-tieredMenu
        #menu
        [model]="jobStatusItems"
        [popup]="true"
        appendTo="body"
    >
        <ng-template
            pTemplate="item"
            let-item
            let-hasSubmenu="hasSubmenu"
        >
            <a pRipple>
                <span class="flex align-items-center p-menuitem-link">
                    <span
                        [class]="item.icon"
                        class="p-menuitem-icon"
                    ></span>
                    <span class="p-menuitem-text">{{ item.label }}</span>
                    <i
                        *ngIf="hasSubmenu"
                        class="pi pi-angle-right p-element p-icon-wrapper"
                    ></i>
                    <span
                        class="p-ink"
                        aria-hidden="true"
                        role="presentation"
                    ></span>
                </span>
                <span
                    class="disabled-message-container p-menuitem-link"
                    *ngIf="item.disabled && item.tooltip"
                >
                    <p class="disabled-message"> {{ item.tooltip }} </p>
                </span>
            </a>
        </ng-template>
    </p-tieredMenu>
</div>